import { defineComponent } from '@vue/composition-api';
import Modal from '@/components/Modal/Modal.vue';
import BackdropLoader from '@/components/BackdropLoader/BackdropLoader.vue';
import MessageTemplate from '@/components/MessageTemplate/MessageTemplate.vue';
export default defineComponent({
    name: 'SurveyModalShell',
    components: {
        Modal,
        BackdropLoader,
        MessageTemplate,
    },
    props: {
        show: { type: Boolean, required: true },
        title: { type: String, required: true },
        isLoading: { type: Boolean, default: false },
    },
    setup(_, ctx) {
        const emitClose = () => {
            ctx.emit('close');
        };
        const handleUpdateShow = (next) => {
            if (!next) {
                emitClose();
            }
        };
        return {
            emitClose,
            handleUpdateShow,
        };
    },
});
